// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "practitioner_service".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
/** Response atom for the "practitioner_service" table (1:1 with a DB row, on the wire). */
export const practitionerServiceAtomSchema = z.object({
    id: z.string(),
    practitionerId: z.string(),
    serviceId: z.string(),
    createdAt: z.string().datetime(),
});
//# sourceMappingURL=practitionerService.js.map